import LargeTextTooltip from './LargeTextTooltip';
export default LargeTextTooltip;
